export default "__VITE_ASSET__D0Ff83eM__"